import { motion } from "framer-motion";
import { PencilLine, MessageCircle, Phone, Compass, ArrowRight } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { JOURNEY_STEPS } from "@/data/content";
import { useBooking } from "@/App";

const ICONS = { PencilLine, MessageCircle, Phone, Compass };

export default function Journey() {
  const { openBooking } = useBooking();
  return (
    <section className="py-24 sm:py-32 bg-ivory" data-testid="journey-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="How It Works"
          title="Your Journey Starts With One Conversation."
          sub="You don't need to diagnose yourself or choose the right framework on your own."
        />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6 relative">
          <div className="hidden lg:block absolute top-10 left-[12%] right-[12%] border-t border-dashed border-gold/40" aria-hidden="true" />
          {JOURNEY_STEPS.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.num} delay={i * 0.1} className="relative">
                <motion.div whileHover={{ y: -6 }} className="text-center px-2" data-testid={`journey-step-${s.num}`}>
                  <div className="relative inline-flex mb-6">
                    <div className="w-20 h-20 rounded-full bg-forest flex items-center justify-center shadow-hover">
                      <Icon size={26} className="text-gold" />
                    </div>
                    <span className="absolute -top-2 -right-4 font-serif italic text-2xl text-gold">
                      {s.num}
                    </span>
                  </div>
                  <h3 className="font-serif text-2xl text-forest">{s.title}</h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-inkmuted max-w-[240px] mx-auto">{s.text}</p>
                </motion.div>
              </Reveal>
            );
          })}
        </div>
        <Reveal delay={0.25} className="text-center mt-16">
          <motion.button
            whileHover={{ scale: 1.04, y: -2 }}
            whileTap={{ scale: 0.97 }}
            onClick={openBooking}
            data-testid="journey-book-discovery-button"
            className="inline-flex items-center gap-2.5 rounded-full bg-forest text-ivory px-8 py-4 text-sm font-bold tracking-wide shadow-hover hover:bg-botanical transition-colors"
          >
            BOOK YOUR FREE 1:1 DISCOVERY CALL <ArrowRight size={16} />
          </motion.button>
          <p className="mt-4 text-sm text-inkmuted font-serif italic text-base">
            "Not sure where to begin? That's okay. You don't have to figure it out alone."
          </p>
        </Reveal>
      </div>
    </section>
  );
}
